import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useTheme, withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { default as MuiCheckbox } from '@material-ui/core/Checkbox';
import { default as MuiInput } from '@material-ui/core/Input';
import { default as MuiSelect } from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';

import ListItemText from '@material-ui/core/ListItemText';

import { default as MuiRadioGroup } from '@material-ui/core/RadioGroup';
import { default as MuiRadio } from '@material-ui/core/Radio';

import { default as MuiTextField } from '@material-ui/core/TextField';

import Popper from '@material-ui/core/Popper';

import { default as StyledTimePicker } from 'rc-time-picker';

import {
    CheckboxIcon,
    CheckboxBlankIcon,
    IconButton,
    CalendarIcon,
    TimeIcon,
    DropdownIcon,
    Span,
    Tag,
    TagDetail,
    EyeIcon,
    EyeOffIcon,
    CrossIcon,
    ContainedButton,
    Text,
    ShowAllIcon,
    DropDownIcon,
    StyledCard,
    StyledCardContent,
    Avatar,
    NextIcon,
    BackIcon,
} from '../index';

import {
    StyledFormControl,
    StyledLabel,
    StyledInput,
    StyledCheckbox,
    StyledFormControlLabel,
    StyledFormGroup,
    StyledDatePicker,
    StyledDateTimePicker,
    StyledKeyboardDatePicker,
    StyledKeyboardTimePicker,
    StyledFormHelperText,
    StyledOutlinedInput,
    useStylesSelect,
    useStylesRadio,
    StyledRadioCard,
    StyledRadioCardContent,
    useStylesRadioCardRadio,
    StyledSelectProviderButton,
} from './style';

import { validNumber } from '../../utils/regex';

import { MONTHS } from '../../constant';

export const Input = (props) => {
    const theme = useTheme();
    const [isFocus, setIsFocus] = useState(false);

    const {
        id,
        label,
        required,
        placeholder,
        onChange,
        value,
        name,
        type,
        defaultValue,
        disabled,
        helperText,
        $inputHeight,
        $inputMaxWidth,
        inputProps,
        onEnter,
        max,
        numberOnly,
        noPublic,
        ...rest
    } = props;

    return (
        <StyledFormControl style={{ maxWidth: $inputMaxWidth ? $inputMaxWidth : '100%' }}>
            {label && (
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                    <StyledLabel htmlFor={id} focus={isFocus ? 1 : 0}>
                        {label} {required && <Span $color="pink">*</Span>}
                    </StyledLabel>
                    {noPublic && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: '5px',
                                marginBottom: '5px',
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: theme.palette.common.gray3,
                                    width: '12px',
                                    height: '9px',
                                    borderRadius: '2px',
                                }}
                            />
                            <Text $color="gray3" $fontSize="10px">
                                Not shown in public
                            </Text>
                        </div>
                    )}
                </div>
            )}
            <StyledInput
                {...rest}
                placeholder={placeholder}
                focus={isFocus ? 1 : 0}
                style={{ border: 'none' }}
                inputProps={{
                    onFocus: () => setIsFocus(true),
                    onBlur: () => setIsFocus(false),
                    onChange: (e) => {
                        if (numberOnly) {
                            if (validNumber.test(e.target.value)) {
                                onChange(e);
                            }
                        } else {
                            onChange(e);
                        }
                    },
                    style: {
                        fontSize: '16px',
                        paddingLeft: '30px',
                        borderRadius: '25px',
                        backgroundColor: disabled ? theme.palette.common.gray6 : '',
                        color: disabled ? theme.palette.common.gray4 : theme.palette.common.black,
                        ...inputProps,
                    },
                    maxLength: max,
                }}
                value={value}
                name={name}
                type={type}
                defaultValue={defaultValue}
                disabled={disabled}
                $inputHeight={$inputHeight ? $inputHeight : '32px'}
                margin="dense"
                variant="outlined"
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && onEnter) {
                        onEnter();
                    }
                }}
                error={Boolean(helperText)}
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

Input.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    helperText: PropTypes.string,
    $inputHeight: PropTypes.string,
    $inputMaxWidth: PropTypes.string,
    inputProps: PropTypes.object,
    onEnter: PropTypes.func,
    max: PropTypes.number,
    numberOnly: PropTypes.bool,
    noPublic: PropTypes.bool,
    rest: PropTypes.object,
};

export const InputWithEndAdornment = (props) => {
    const theme = useTheme();
    const [isFocus, setIsFocus] = useState(false);

    const {
        id,
        label,
        required,
        placeholder,
        onChange,
        endAdornment,
        value,
        name,
        type,
        defaultValue,
        disabled,
        helperText,
        error,
        $inputHeight,
        inputProps,
        inputPropsStyle,
        $styleFormControl,
        $backgroundColor,
        startAdornment,
        ...rest
    } = props;

    return (
        <StyledFormControl style={$styleFormControl}>
            {label && (
                <StyledLabel htmlFor={id} focus={isFocus ? 1 : 0}>
                    {label} {required && <Span $color="pink">*</Span>}
                </StyledLabel>
            )}
            <StyledOutlinedInput
                {...rest}
                placeholder={placeholder}
                focus={isFocus ? 1 : 0}
                inputProps={{
                    onFocus: () => setIsFocus(true),
                    onBlur: () => setIsFocus(false),
                    onChange: (e) => onChange(e),
                    style: {
                        color: theme.palette.common.black,
                        paddingLeft: '30px',
                        borderRadius: '25px',
                        ...inputPropsStyle,
                    },
                    ...inputProps,
                }}
                startAdornment={startAdornment}
                endAdornment={endAdornment}
                value={value}
                name={name}
                type={type}
                defaultValue={defaultValue}
                disabled={disabled}
                $inputHeight={$inputHeight ? $inputHeight : '32px'}
                margin="dense"
                variant="outlined"
                $backgroundColor={$backgroundColor}
                error={Boolean(helperText) || error}
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

InputWithEndAdornment.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    endAdornment: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    type: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    helperText: PropTypes.string,
    $inputHeight: PropTypes.string,
    inputProps: PropTypes.object,
    $styleFormControl: PropTypes.object,
    $backgroundColor: PropTypes.string,
    startAdornment: PropTypes.node,
    rest: PropTypes.object,
};

export const PasswordInput = (props) => {
    const theme = useTheme();
    const [isFocus, setIsFocus] = useState(false);

    const [showPassword, setShowPassword] = React.useState(false);

    const {
        id,
        label,
        required,
        placeholder,
        onChange,
        value,
        name,
        defaultValue,
        disabled,
        helperText,
        onEnter,
        ...rest
    } = props;

    return (
        <StyledFormControl>
            <StyledLabel htmlFor={id} focus={isFocus ? 1 : 0}>
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            <StyledOutlinedInput
                {...rest}
                style={{ border: 'none' }}
                placeholder={placeholder}
                focus={isFocus ? 1 : 0}
                inputProps={{
                    onFocus: () => setIsFocus(true),
                    onBlur: () => setIsFocus(false),
                    onChange: (e) => onChange(e),
                    style: {
                        color: theme.palette.common.black,
                        paddingLeft: '30px',
                        fontSize: '16px',
                        backgroundColor: disabled ? theme.palette.common.gray6 : '',
                    },
                    maxLength: 30,
                }}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            disabled={disabled}
                        >
                            {showPassword ? <EyeIcon /> : <EyeOffIcon />}
                        </IconButton>
                    </InputAdornment>
                }
                value={value}
                name={name}
                type={showPassword ? 'text' : 'password'}
                defaultValue={defaultValue}
                disabled={disabled}
                margin="dense"
                variant="outlined"
                error={Boolean(helperText)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && onEnter) {
                        onEnter();
                    }
                }}
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

PasswordInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    helperText: PropTypes.string,
    onEnter: PropTypes.func,
    rest: PropTypes.object,
};

export const CheckboxGroup = (props) => {
    const { id, label, required, children, ...rest } = props;
    return (
        <StyledFormControl {...rest}>
            <StyledLabel htmlFor={id} $color="gray2">
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            {children}
        </StyledFormControl>
    );
};

CheckboxGroup.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const Checkbox = (props) => {
    const { checked, onChange, name, label, fill, ...rest } = props;
    return (
        <FormControlLabel
            control={
                <StyledCheckbox
                    checked={checked}
                    onChange={onChange}
                    name={name}
                    icon={<CheckboxBlankIcon />}
                    checkedIcon={<CheckboxIcon fill={fill} />}
                    {...rest}
                />
            }
            label={label}
        />
    );
};

Checkbox.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.any,
    fill: PropTypes.string,
    rest: PropTypes.object,
};

export const FormControlLabel = (props) => {
    const { ...rest } = props;
    return <StyledFormControlLabel {...rest} />;
};

FormControlLabel.propTypes = {
    rest: PropTypes.object,
};

export const FormGroup = (props) => {
    const { children, ...rest } = props;
    return <StyledFormGroup {...rest}>{children}</StyledFormGroup>;
};

FormGroup.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const TextField = (props) => {
    const theme = useTheme();

    const {
        id,
        label,
        required,
        minRows,
        placeholder,
        value,
        onChange,
        $inputMaxWidth,
        helperText,
        disabled,
        inputProps,
        ...rest
    } = props;
    return (
        <StyledFormControl style={{ maxWidth: $inputMaxWidth ? $inputMaxWidth : '100%' }}>
            {label && (
                <StyledLabel htmlFor={id}>
                    {label} {required && <Span $color="pink">*</Span>}
                </StyledLabel>
            )}
            <MuiTextField
                {...rest}
                id={id}
                multiline
                minRows={minRows ? minRows : 4}
                variant="outlined"
                placeholder={placeholder}
                fullWidth
                style={{
                    borderRadius: '16px',
                    backgroundColor: disabled
                        ? theme.palette.common.gray6
                        : theme.palette.common.white,
                }}
                InputProps={{
                    style: {
                        borderRadius: '16px',
                        color: disabled ? theme.palette.common.gray4 : theme.palette.common.black,
                    },
                }}
                inputProps={{
                    style: {
                        minHeight: '21px',
                    },
                    ...inputProps,
                }}
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

TextField.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    minRows: PropTypes.number,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    $inputMaxWidth: PropTypes.string,
    helperText: PropTypes.string,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
};

export const DatePicker = (props) => {
    return (
        <StyledDatePicker
            {...props}
            format="MM/dd/yyyy"
            id="date-picker-inline"
            label="Date picker inline"
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
        />
    );
};

export const TimePicker = (props) => {
    const { value, onChange, disabled, helperText, error, ...rest } = props;

    const [open, setOpen] = useState(false);
    const [time, setTime] = useState('');

    const onTimeChange = (time) => {
        const formatted = time.format('HH:mm');
        setTime(formatted);
        onChange(formatted);
    };

    useEffect(() => {
        setTime(value);
    }, [value]);

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <InputWithEndAdornment
                {...rest}
                disabled={disabled}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            style={{ height: 'auto', width: 'auto' }}
                            onClick={() => setOpen(true)}
                            disabled={disabled}
                        >
                            <TimeIcon width="16" height="16" fill={disabled ? 'gray4' : 'black'} />
                        </IconButton>
                    </InputAdornment>
                }
                // $disabledColor="black"
                value={time}
                onChange={() => {}}
                error={Boolean(helperText)}
            />

            <StyledTimePicker
                open={open}
                style={{
                    visibility: 'hidden',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                }}
                popupStyle={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1300,
                }}
                showSecond={false}
                onChange={onTimeChange}
                onClose={() => setOpen(false)}
                focusOnOpen
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </div>
    );
};

TimePicker.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    helperText: PropTypes.string,
    rest: PropTypes.object,
};

export const DateTimePicker = (props) => {
    return <StyledDateTimePicker {...props} />;
};

export const KeyboardDatePicker = (props) => {
    const theme = useTheme();

    const {
        id,
        label,
        required,
        $inputHeight,
        $inputMaxWidth,
        disabled,
        placeholder,
        helperText,
        format,
        onValidationError,
        ...rest
    } = props;

    return (
        <StyledFormControl style={{ maxWidth: $inputMaxWidth ? $inputMaxWidth : '100%' }}>
            <StyledLabel htmlFor={id}>
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            <StyledKeyboardDatePicker
                {...rest}
                autoOk
                variant="inline"
                inputVariant="outlined"
                format={format ? format : 'DD/MM/YYYY'}
                placeholder={placeholder ? placeholder : 'Select Date'}
                InputAdornmentProps={{ position: 'end' }}
                maxDateMessage={helperText ? false : undefined}
                minDateMessage={helperText ? false : undefined}
                invalidDateMessage={helperText ? false : undefined}
                keyboardIcon={
                    <CalendarIcon width="16" height="16" fill={disabled ? 'gray4' : 'black'} />
                }
                InputProps={{
                    style: {
                        borderRadius: '25px',
                        padding: 0,
                        backgroundColor: disabled
                            ? theme.palette.common.gray6
                            : theme.palette.common.white,
                        width: '100%',
                        height: $inputHeight ? $inputHeight : '32px',
                        color: disabled ? theme.palette.common.gray4 : theme.palette.common.black,
                    },
                }}
                inputProps={{
                    style: {
                        padding: '10px 25px',
                    },
                }}
                disabled={disabled}
                error={Boolean(helperText)}
                onError={(reason, value) => {
                    if (onValidationError && reason) {
                        onValidationError(reason);
                    }
                }}
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

KeyboardDatePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    $inputHeight: PropTypes.string,
    $inputMaxWidth: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    helperText: PropTypes.string,
    format: PropTypes.string,
    rest: PropTypes.object,
};

export const KeyboardTimePicker = (props) => {
    const theme = useTheme();

    const {
        id,
        label,
        required,
        $inputHeight,
        $inputMaxWidth,
        disabled,
        placeholder,
        helperText,
        ...rest
    } = props;

    return (
        <StyledFormControl style={{ maxWidth: $inputMaxWidth ? $inputMaxWidth : '100%' }}>
            <StyledLabel htmlFor={id}>
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            <StyledKeyboardTimePicker
                {...rest}
                autoOk
                variant="inline"
                inputVariant="outlined"
                placeholder={placeholder ? placeholder : 'Select'}
                ampm={false}
                InputAdornmentProps={{ position: 'end' }}
                keyboardIcon={
                    <TimeIcon width="16" height="16" fill={disabled ? 'gray4' : 'black'} />
                }
                InputProps={{
                    style: {
                        borderRadius: '25px',
                        padding: 0,
                        backgroundColor: disabled
                            ? theme.palette.common.gray6
                            : theme.palette.common.white,
                        width: '100%',
                        height: $inputHeight ? $inputHeight : '32px',
                        color: disabled ? theme.palette.common.gray4 : theme.palette.common.black,
                    },
                }}
                inputProps={{
                    style: {
                        padding: '10px 0 10px 25px',
                    },
                }}
                disabled={disabled}
            />
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

KeyboardTimePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    $inputHeight: PropTypes.string,
    $inputMaxWidth: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    helperText: PropTypes.string,
    rest: PropTypes.object,
};

export const RadioGroup = (props) => {
    const { label, name, value, onChange, required, children, helperText, ...rest } = props;

    return (
        <StyledFormControl>
            <StyledLabel $color="gray2">
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            <MuiRadioGroup
                {...rest}
                aria-label={label}
                name={name}
                value={value}
                onChange={onChange}
            >
                {children}
            </MuiRadioGroup>
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

RadioGroup.propTypes = {
    label: PropTypes.any,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    children: PropTypes.any,
    helperText: PropTypes.string,
    rest: PropTypes.object,
};

export const Radio = (props) => {
    const { value, label, disabled, ...rest } = props;

    const classes = useStylesRadio();

    return (
        <FormControlLabel
            {...rest}
            value={value}
            disabled={disabled}
            control={<MuiRadio color="secondary" className={classes.root} />}
            label={label}
        />
    );
};

Radio.propTypes = {
    value: PropTypes.string,
    label: PropTypes.any,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
};

export const RadioCard = (props) => {
    const { handleChange, selectedValue, value, label, subtitle, content } = props;

    const classes = useStylesRadioCardRadio();

    return (
        <StyledRadioCard active={selectedValue === value} onClick={() => handleChange(value)}>
            <MuiRadio
                checked={selectedValue === value}
                value={value}
                name="RadioCard"
                inputProps={{ 'aria-label': label }}
                className={classes.root}
            />
            <StyledRadioCardContent>
                {label && <Text $fontSize="18px">{label}</Text>}
                {subtitle && (
                    <Text $fontSize="16px" $color="gray1">
                        {subtitle}
                    </Text>
                )}
                {content && (
                    <Text $fontSize="14px" $color="gray2">
                        {content}
                    </Text>
                )}
            </StyledRadioCardContent>
        </StyledRadioCard>
    );
};

RadioCard.propTypes = {
    handleChange: PropTypes.func,
    selectedValue: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.any,
    subtitle: PropTypes.string,
    content: PropTypes.any,
};

export const TagAdd = (props) => {
    const { label, required, data, onAddTag, helperText, disabled, onClickTag, ...rest } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedTag, setSelectedTag] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(null);

    const onClose = () => {
        setSelectedTag('');
        setSelectedIndex(null);
        setAnchorEl(null);
    };

    const onAdd = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const onSave = (value) => {
        const newData = [...data];

        if (selectedIndex !== null) {
            newData[selectedIndex] = value;
        } else {
            newData.push(value);
        }

        onClose();
        onAddTag(newData);
    };

    const onClick = (event, value, index) => {
        if (onClickTag) {
            onClickTag(value);
        } else {
            setAnchorEl(event.currentTarget);
            setSelectedTag(value);
            setSelectedIndex(index);
        }
    };

    const onDelete = () => {
        const newData = [...data];
        newData.splice(selectedIndex, 1);
        onClose();
        onAddTag(newData);
    };

    return (
        <StyledFormControl {...rest}>
            <TagDetail
                anchorEl={anchorEl}
                placement={'top-start'}
                popperStyle={{ marginTop: '10px', marginBottom: '10px' }}
                data={selectedTag}
                onSave={onSave}
                onDelete={onDelete}
                onClose={onClose}
            />
            <StyledLabel>
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    columnGap: '10px',
                    rowGap: '10px',
                    paddingLeft: '20px',
                }}
            >
                {data &&
                    data.length > 0 &&
                    data.map((tag, index) => (
                        <Tag
                            key={tag + index}
                            onClick={(e) => onClick(e, tag, index)}
                            disabled={disabled}
                        >
                            {tag}
                        </Tag>
                    ))}
                <Tag onClick={onAdd} disabled={disabled}>
                    + Add
                </Tag>
            </div>
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

TagAdd.propTypes = {
    label: PropTypes.any,
    required: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.string),
    onAddTag: PropTypes.func,
    helperText: PropTypes.string,
    disabled: PropTypes.bool,
    onClickTag: PropTypes.func,
    rest: PropTypes.object,
};

export const TagSelect = (props) => {
    const theme = useTheme();
    const { value, onChange, options, ...rest } = props;
    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);

    const handleOpen = () => setOpen(true);

    return (
        <MuiSelect
            {...rest}
            disableUnderline
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={value}
            onChange={onChange}
            open={open}
            onClose={handleClose}
            onOpen={handleOpen}
            input={
                <MuiInput
                    style={{
                        backgroundColor: theme.palette.common.purple,
                        color: theme.palette.common.white,
                        borderRadius: '16px',
                        height: '24px',
                        width: 'fit-content',
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '5px',
                        cursor: 'pointer',
                    }}
                />
            }
            renderValue={() => <p style={{ paddingLeft: '16px' }}>Emotion</p>}
            SelectDisplayProps={{
                style: {
                    backgroundColor: 'transparent',
                    padding: 0,
                    fontSize: '14px',
                },
            }}
            IconComponent={() => (
                <div
                    onClick={() => handleOpen()}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        paddingRight: '16px',
                    }}
                >
                    <DropdownIcon />
                </div>
            )}
            MenuProps={{
                PaperProps: { style: { borderRadius: '16px', minWidth: '170px' } },
                MenuListProps: { style: { padding: 0 } },
                getContentAnchorEl: () => null,
            }}
        >
            {options.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    <MuiCheckbox checked={value.some((v) => v === option.id)} />
                    <ListItemText
                        primary={option.strEmotion}
                        style={{ textTransform: 'capitalize' }}
                    />
                </MenuItem>
            ))}
        </MuiSelect>
    );
};

TagSelect.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
    rest: PropTypes.object,
};

export const Select = (props) => {
    const {
        name,
        value,
        onChange,
        options,
        label,
        $inputHeight,
        placeholder,
        required,
        deselect,
        helperText,
        disabled,
        ...rest
    } = props;

    const classes = useStylesSelect({ $inputHeight, disabled });

    const [open, setOpen] = useState(false);

    return (
        <StyledFormControl>
            {label && (
                <StyledLabel $color="gray2">
                    {label} {required && <Span $color="pink">*</Span>}
                </StyledLabel>
            )}
            <MuiSelect
                margin="dense"
                variant="outlined"
                className={classes.root}
                name={name}
                value={value}
                onChange={onChange}
                displayEmpty={placeholder ? true : false}
                IconComponent={() => (
                    <div
                        style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            right: '5%',
                            display: 'flex',
                            alignItems: 'center',
                            pointerEvents: 'none',
                            transform: open ? 'rotate(180deg)' : 'rotate(0)',
                        }}
                    >
                        <DropdownIcon fill="black" width="16px" height="16px" />
                    </div>
                )}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                open={open}
                disabled={disabled}
                {...rest}
            >
                {placeholder && (
                    <MenuItem value="" disabled style={{ display: 'none' }}>
                        <Span style={{ color: '#B0B3BF' }}>{placeholder}</Span>
                    </MenuItem>
                )}
                {deselect && <MenuItem value="none">None</MenuItem>}
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                        {option.text}
                    </MenuItem>
                ))}
            </MuiSelect>
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </StyledFormControl>
    );
};

Select.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
    label: PropTypes.any,
    $inputHeight: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    deselect: PropTypes.bool,
    helperText: PropTypes.string,
    disabled: PropTypes.bool,
    rest: PropTypes.object,
};

export const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 40,
        height: 20,
        padding: 0,
    },
    switchBase: {
        padding: 2,
        color: theme.palette.common.black,
        '&$checked': {
            transform: 'translateX(20px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: theme.palette.common.primaryBlue,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.common.primaryBlue,
            border: '6px solid #fff',
        },
        transition: theme.transitions.create(['color', 'transform']),
    },
    thumb: {
        width: 16,
        height: 16,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.common.black}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export const AddMoreInput = (props) => {
    const theme = useTheme();

    const {
        values,
        placeholder,
        label,
        required,
        id,
        disabled,
        helperText,
        onAddMore,
        onRemove,
        onChange,
        name,
        ...rest
    } = props;

    const [isFocus, setIsFocus] = useState(false);

    return (
        <div>
            <StyledLabel htmlFor={id} focus={isFocus ? 1 : 0}>
                {label} {required && <Span $color="pink">*</Span>}
            </StyledLabel>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {!_.isEmpty(values) &&
                    values.map((value, index) => (
                        <StyledFormControl key={`addMoreInput-${index}`} {...rest}>
                            <StyledOutlinedInput
                                style={{ border: 'none' }}
                                placeholder={placeholder}
                                inputProps={{
                                    onFocus: () => setIsFocus(true),
                                    onBlur: () => setIsFocus(false),
                                    onChange: (e) => onChange(name, index, e.target.value),
                                    style: {
                                        color: theme.palette.common.black,
                                        paddingLeft: '30px',
                                        backgroundColor: disabled ? theme.palette.common.gray6 : '',
                                    },
                                    maxLength: 100,
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => onRemove(name, index)}
                                            disabled={disabled}
                                        >
                                            <CrossIcon fill="gray2" />
                                        </IconButton>
                                    </InputAdornment>
                                }
                                value={value}
                                type="text"
                                name={name}
                                disabled={disabled}
                                margin="dense"
                                variant="outlined"
                            />
                        </StyledFormControl>
                    ))}
                <ContainedButton
                    $backgroundColor="gray6"
                    $noShadow
                    onClick={() => onAddMore(name)}
                    disabled={disabled}
                >
                    <Text $color={disabled ? 'gray4' : 'primaryBlue'}>+ Add more</Text>
                </ContainedButton>
            </div>
            {helperText && <StyledFormHelperText error>{helperText}</StyledFormHelperText>}
        </div>
    );
};

AddMoreInput.propTypes = {
    values: PropTypes.arrayOf(PropTypes.string),
    placeholder: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    helperText: PropTypes.string,
    onAddMore: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    name: PropTypes.string,
    rest: PropTypes.object,
};

export const SelectProvider = ({ staffOptions, selectedStaff, setSelectedStaff, $small }) => {
    const user = useSelector((state) => state.user);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'select-provider-popper' : undefined;

    const handleSelect = (value) => {
        setSelectedStaff(value);
        setAnchorEl(null);
    };

    const popperRef = useRef(null);

    // hide popper if click somewhere else
    const handleClickOutside = (event) => {
        if (open && popperRef.current && !popperRef.current.contains(event.target)) {
            setAnchorEl(null);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, false);
        return () => {
            document.removeEventListener('click', handleClickOutside, false);
        };
    }, [open]);

    return (
        <StyledFormControl>
            {selectedStaff === '' ? (
                <StyledSelectProviderButton
                    onClick={handleOpen}
                    style={{
                        background:
                            'linear-gradient(256.13deg, #FFFFFF 0%, rgba(255, 255, 255, 0.19) 100%, rgba(255, 255, 255, 0.2) 100%)',
                        height: $small ? '36px' : '48px',
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                            padding: '15px',
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr auto',
                            alignItems: 'center',
                            columnGap: '10px',
                        }}
                    >
                        <ShowAllIcon />
                        <Text $fontSize="14px" $medium style={{ textAlign: 'left' }}>
                            Show All
                        </Text>
                        <DropDownIcon />
                    </div>
                </StyledSelectProviderButton>
            ) : (
                <ProviderButton
                    data={staffOptions.find((option) => option.value === selectedStaff)}
                    onClick={handleOpen}
                    user={user}
                    buttonStyle={{
                        height: $small ? '36px' : '48px',
                    }}
                    $avatarSize={$small ? '24px' : '30px'}
                />
            )}
            <Popper
                ref={popperRef}
                id={id}
                open={open}
                anchorEl={anchorEl}
                placement="bottom-start"
                style={{ marginTop: '10px' }}
            >
                <SelectProviderCard
                    options={staffOptions}
                    handleSelect={handleSelect}
                    user={user}
                />
            </Popper>
        </StyledFormControl>
    );
};

SelectProvider.propTypes = {
    staffOptions: PropTypes.arrayOf(PropTypes.object),
    selectedStaff: PropTypes.string,
    setSelectedStaff: PropTypes.func,
    $small: PropTypes.bool,
};

const SelectProviderCard = ({ options, handleSelect, user }) => {
    const theme = useTheme();

    const [searchValue, setSearchValue] = useState('');
    const [providerListData, setProviderListData] = useState([]);

    useEffect(() => {
        if (options) {
            if (!searchValue) {
                setProviderListData(options);
            } else {
                const newProviderListData = options.filter((option) =>
                    option.text.toLowerCase().includes(searchValue.toLowerCase())
                );
                setProviderListData(newProviderListData);
            }
        }
    }, [options, searchValue]);

    const onChange = (e) => {
        setSearchValue(e.target.value);
    };

    return (
        <StyledCard padding="25px 10px 15px" $width="378px" $backgroundColor="white">
            <StyledCardContent>
                <MuiTextField
                    variant="outlined"
                    placeholder="Search"
                    fullWidth
                    style={{
                        borderRadius: '8px',
                        backgroundColor: theme.palette.common.white,
                    }}
                    InputProps={{
                        style: {
                            borderRadius: '8px',
                            color: theme.palette.common.black,
                        },
                    }}
                    inputProps={{
                        style: {
                            height: '38px',
                            padding: '0 15px',
                        },
                    }}
                    value={searchValue}
                    onChange={onChange}
                />
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        rowGap: '10px',
                        marginTop: '20px',
                        maxHeight: '500px',
                        overflowY: 'auto',
                    }}
                >
                    <StyledSelectProviderButton
                        $borderColor="black"
                        $backgroundColor="black"
                        onClick={() => handleSelect('')}
                    >
                        <div
                            style={{
                                width: '100%',
                                padding: '15px',
                                display: 'grid',
                                gridTemplateColumns: 'auto 1fr',
                                alignItems: 'center',
                                columnGap: '10px',
                            }}
                        >
                            <ShowAllIcon fill="white" />
                            <Text
                                $fontSize="14px"
                                $color="white"
                                $bold
                                style={{ textAlign: 'left' }}
                            >
                                Show All
                            </Text>
                        </div>
                    </StyledSelectProviderButton>
                    {!_.isEmpty(providerListData) &&
                        providerListData.map((item) => (
                            <ProviderButton
                                key={item.value}
                                data={item}
                                onClick={() => handleSelect(item.value)}
                                user={user}
                            />
                        ))}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

SelectProviderCard.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    handleSelect: PropTypes.func,
    user: PropTypes.object,
};

export const ProviderButton = ({
    data,
    onClick,
    user,
    $avatarSize,
    buttonStyle,
    containerStyle,
}) => {
    return (
        <StyledSelectProviderButton
            $backgroundColor="gray13"
            style={{
                border: 'none',
                ...buttonStyle,
            }}
            onClick={onClick}
        >
            <div
                style={{
                    width: '100%',
                    padding: '15px',
                    display: 'grid',
                    gridTemplateColumns: 'auto 1fr auto',
                    alignItems: 'center',
                    columnGap: '10px',
                    ...containerStyle,
                }}
            >
                <Avatar
                    src={data?.avatar}
                    alt={data?.text}
                    $avatarSize={$avatarSize ? $avatarSize : '30px'}
                    $borderRadius="50%"
                />
                <Text $fontSize="14px" $medium $ellipsis $lineClamp style={{ textAlign: 'left' }}>
                    {data?.text}
                </Text>
                {data?.value === user?.staff?.id && (
                    <Text $fontSize="14px" $medium $color="blue2">
                        My account
                    </Text>
                )}
            </div>
        </StyledSelectProviderButton>
    );
};

ProviderButton.propTypes = {
    data: PropTypes.object,
    onClick: PropTypes.func,
    user: PropTypes.object,
    $avatarSize: PropTypes.string,
    buttonStyle: PropTypes.object,
    containerStyle: PropTypes.object,
};

export const MonthSelector = ({
    selectedMonth,
    selectedYear,
    setSelectedMonth,
    setSelectedYear,
}) => {
    const handleChangeMonth = (value) => {
        const newMonth = selectedMonth + value;
        if (newMonth < 0) {
            setSelectedMonth(11);
            setSelectedYear(selectedYear - 1);
        } else if (newMonth > 11) {
            setSelectedMonth(0);
            setSelectedYear(selectedYear + 1);
        } else {
            setSelectedMonth(newMonth);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '250px',
            }}
        >
            <ContainedButton
                $width="28px"
                $height="28px"
                $backgroundColor="gray6"
                $noShadow
                style={{
                    minWidth: 0,
                    borderRadius: '8px',
                    padding: 0,
                }}
                onClick={() => handleChangeMonth(-1)}
            >
                <BackIcon />
            </ContainedButton>
            <Text $fontSize="20px" $bold>
                {`${MONTHS[selectedMonth]} ${selectedYear}`}
            </Text>

            <ContainedButton
                $width="28px"
                $height="28px"
                $backgroundColor="gray6"
                $noShadow
                style={{
                    minWidth: 0,
                    borderRadius: '8px',
                    padding: 0,
                }}
                onClick={() => handleChangeMonth(1)}
            >
                <NextIcon fill="black" />
            </ContainedButton>
        </div>
    );
};

MonthSelector.propTypes = {
    selectedMonth: PropTypes.number.isRequired,
    selectedYear: PropTypes.number.isRequired,
    setSelectedMonth: PropTypes.func.isRequired,
    setSelectedYear: PropTypes.func.isRequired,
};
